const imagesWithOriginalSrc = new RegExp(
    '<IMG[^>]+?ORIGINALSRC\\s*=\\s*"[\\s\\S]+?"[\\s\\S]*?>',
    'gim'
);
const srcAttribute = new RegExp('\\sSRC\\s*=\\s*"[\\s\\S]+?"', 'im');

export default function removeSrcAttributeFromInlineImages(html: string): string {
    if (html) {
        return html.replace(imagesWithOriginalSrc, function(imgTagStr: string) {
            return imgTagStr.replace(srcAttribute, '');
        });
    } else {
        return html;
    }
}
